<ion-item>

  <ion-label class="title">{{ title }}</ion-label>

  <ion-note
    slot="end"
    [ngClass]="{highlight}"
  >
    {{ isCurrency ? ((data || 0) | currency: 'EUR': 'symbol': '1.2-2': 'es') : data }}
  </ion-note>

</ion-item>
